// extracted by mini-css-extract-plugin
module.exports = {"donate-button":"donate_button__donate-button___3tDcl","preview":"donate_button__preview___2cFqo"};